module.exports = __webpack_public_path__ + "img/shotgun.spas12.d39db574.png";